/*
  Carrito lateral de Costa Sneakers.

  Lo unico que aporta sobre la maquinaria de Dawn es la doble cara del titulo:
  "Tu carrito" cuando el comprador abre el cajon desde el icono del encabezado,
  y "Agregado al carrito" en verde justo despues de agregar un producto, que es
  el estado 08 del Figma.

  Se engancha al evento cartUpdate que ya publica product-form.js en vez de
  espiar el DOM, y solo reacciona cuando el origen es un formulario de producto:
  cambiar una cantidad dentro del carrito no es "agregar".
*/

(function () {
  'use strict';

  var JUST_ADDED_TEXT = 'Agregado al carrito';
  var JUST_ADDED_CLASS = 'is-just-added';
  var defaultTitle = null;

  function titleNode() {
    return document.querySelector('[data-costa-cart-title]');
  }

  function markJustAdded() {
    var node = titleNode();
    if (!node) return;

    if (defaultTitle === null) defaultTitle = node.textContent.trim();

    node.textContent = JUST_ADDED_TEXT;
    node.classList.add(JUST_ADDED_CLASS);
  }

  function resetTitle() {
    var node = titleNode();
    if (!node || defaultTitle === null) return;

    node.textContent = defaultTitle;
    node.classList.remove(JUST_ADDED_CLASS);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      // renderContents reemplaza el contenido del cajon, asi que el titulo se
      // marca despues de que el nuevo nodo ya esta en el documento.
      requestAnimationFrame(markJustAdded);
    });

    // Al cerrar el cajon el mensaje deja de tener sentido: la proxima vez que se
    // abra desde el icono debe decir "Tu carrito" otra vez.
    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      if (event.target.closest('#CartDrawer-Overlay') || event.target.closest('.drawer__close')) {
        resetTitle();
      }
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') resetTitle();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
